export default {
  brand: "USFansLink.study",

  nav_home: "Inicio",
  nav_categories: "Categorías",
  nav_articles: "Guías",
  nav_visit: "Visitar sitio principal",

  dropdown_label: "Explorar categorías",

  hero_eyebrow: "CENTRO DE RECURSOS USFANS SPREADSHEET",
  hero_title: "USFans Spreadsheet: encuentra, compara y explora recursos actualizados",
  hero_subtitle:
    "¿Buscas una forma más clara de explorar los recursos de USFans spreadsheet? USFansLink.study organiza guías, reseñas, información de envío, recursos de almacén, cupones, comparaciones e información de seguridad en un hub fácil de navegar.",
  hero_cta_primary: "Explorar USFans Spreadsheet",
  hero_cta_secondary: "Leer la guía para principiantes",
  hero_trust: "Información independiente • Guías prácticas • Recursos centrados en seguridad",

  search_title: "Buscar recursos de USFans Spreadsheet",
  search_placeholder: "Busca USFans spreadsheet, envío, almacén, reseñas o cupones...",
  search_popular: "Búsquedas populares",
  search_tags: ["USFans Spreadsheet", "Reseña USFans", "Coste de envío USFans", "Cupón USFans", "Almacén USFans", "¿USFans es legítimo?"],

  topics_title: "Temas populares",
  topics_subtitle: "Empieza por el tema que más te importa.",

  topic_1_title: "USFans Spreadsheet",
  topic_1_desc: "Explora recursos, categorías y guías de spreadsheet.",
  topic_2_title: "Reseña de USFans",
  topic_2_desc: "Comprende la plataforma, sus funciones y puntos clave.",
  topic_3_title: "Coste de envío de USFans",
  topic_3_desc: "Descubre qué afecta a los precios y cómo comparar opciones.",
  topic_4_title: "Cupón de USFans",
  topic_4_desc: "Aprende cómo funcionan los cupones y cómo verificarlos.",
  topic_5_title: "Almacén de USFans",
  topic_5_desc: "Comprende el almacenamiento, el procesamiento y la información relacionada.",
  topic_6_title: "¿USFans es legítimo?",
  topic_6_desc: "Aprende a evaluar señales de confianza y a mantenerte seguro.",

  value_title: "Todo lo que necesitas para entender los recursos de USFans Spreadsheet",
  value_subtitle:
    "Los recursos de USFans spreadsheet pueden contener información útil, pero encontrarla, compararla y verificarla puede ser difícil. Nuestro objetivo es organizar los temas importantes en guías prácticas y fáciles de entender.",
  value_1_title: "DESCUBRIR",
  value_1_desc: "Encuentra recursos relevantes de USFans spreadsheet.",
  value_2_title: "COMPARAR",
  value_2_desc: "Compara información, opciones, costes y funciones.",
  value_3_title: "VERIFICAR",
  value_3_desc: "Aprende a revisar fechas, enlaces, afirmaciones e información de terceros.",

  featured_title: "USFans Spreadsheet: tu punto de partida",
  featured_subtitle:
    "Empieza por el hub de USFans Spreadsheet para explorar guías, categorías, comparaciones, preguntas frecuentes y recursos actualizados.",
  featured_cta: "Abrir el hub de USFans Spreadsheet",

  compare_title: "¿Qué estás buscando?",
  compare_col_topic: "Tema",
  compare_col_best: "Ideal para",
  compare_col_info: "Información principal",
  compare_rows: [
    ["USFans Spreadsheet", "Descubrir recursos", "Listas, categorías y guías"],
    ["Reseña de USFans", "Investigar la plataforma", "Funciones y consideraciones"],
    ["Coste de envío", "Investigar el envío", "Factores de coste y opciones"],
    ["Cupón", "Investigar ofertas", "Cupones y promociones"],
    ["Almacén", "Investigar el almacén", "Almacenamiento y procesamiento"],
    ["¿USFans es legítimo?", "Investigar la confianza", "Verificación y seguridad"],
  ],

  trust_title: "Infórmate antes de decidir",
  trust_subtitle:
    "La información en línea cambia rápido. Un spreadsheet, un cupón, una estimación de envío o un enlace de terceros no debe considerarse exacto solo porque aparece en línea. Verifica las fechas, la información importante y usa fuentes oficiales para acciones sensibles.",
  trust_cta: "Leer la guía de seguridad",

  final_title: "¿Listo para explorar los recursos de USFans Spreadsheet?",
  final_subtitle:
    "Empieza por el hub de USFans Spreadsheet, explora nuestras últimas guías y usa la información para tomar mejores decisiones.",
  final_cta: "Explorar USFans Spreadsheet",
  final_secondary: "Visitar sitio principal",

  btn_buy_now: "comprar ahora",
  btn_usfans: "usfans spreadsheet",

  categories_title: "Explorar todas las categorías",
  categories_subtitle: "Accede directamente a la sección que necesitas en el sitio principal.",

  articles_title: "Últimas guías de USFans Spreadsheet",
  articles_subtitle: "Guías originales y útiles para comprender los recursos de USFans.",
  article_1_title: "¿Qué es USFans Spreadsheet? Guía completa para principiantes",
  article_1_desc:
    "Una introducción clara y original a los recursos de USFans spreadsheet: qué son, cómo ayudan y cómo empezar a usarlos con seguridad.",
  article_read: "Leer la guía",
  article_more: "Más guías próximamente",
  article_related: "Guías relacionadas",

  nav_shop_guide: "Guía de compra",
  guide_eyebrow: "CÓMO COMPRAR",
  guide_title: "Tu guía de compra de USFans",
  guide_intro:
    "Una guía sencilla, paso a paso, para explorar las categorías de USFans y completar tu pedido en el sitio oficial.",
  guide_steps_title: "Cómo comprar en cuatro pasos",
  guide_steps: [
    { title: "Elige una categoría", desc: "Elige una categoría como zapatos, sudaderas o bolsos." },
    { title: "Explora la selección", desc: "Abre la categoría en el sitio oficial y compara los artículos disponibles." },
    { title: "Revisa los detalles", desc: "Confirma el precio, la disponibilidad, el envío y la entrega antes de decidir." },
    { title: "Completa tu pedido", desc: "Termina el pago de forma segura en el sitio oficial y guarda un registro." },
  ],
  guide_cta_title: "¿Listo para empezar a comprar?",
  guide_cta_desc: "Ve al sitio oficial y explora la gama completa de USFans a tu ritmo.",
  guide_back_home: "Volver al inicio",

  footer_about: "USFansLink.study es un recurso de información independiente. No está afiliado a USFans ni a ningún servicio de terceros mencionado en este sitio.",
  footer_disclaimer: "La información puede cambiar y debe verificarse de forma independiente.",
  footer_links: "Enlaces rápidos",
  footer_categories: "Categorías",
  footer_rights: "Todos los derechos reservados.",

  cats: {
    shoes: "Zapatos",
    hoodies: "Sudadera / Suéteres",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones / Shorts",
    headwear: "Gorros",
    sets: "Conjuntos",
    underwear: "Ropa interior",
    jersey: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otras cosas",
  },
};